export default "__VITE_ASSET__BwbRdEfj__"